import React from 'react';
import { Typography } from 'components/Typography';
import * as Styled from './AskProductOrderDetailsToggle.styles';
import { IProduct } from '../../types';
import { getUniqueProducts } from '../../utils/getUniqueProducts';

interface AskProductOrderDetailsToggleProps {
  products: IProduct[];
  isOrderDetailsOpen: boolean;
  onToggleClick: () => void;
  hideDetailsLabel?: string;
  compact?: boolean;
}

export const AskProductOrderDetailsToggle: React.FC<
  AskProductOrderDetailsToggleProps
> = (props) => {
  const {
    isOrderDetailsOpen,
    onToggleClick,
    products,
    hideDetailsLabel = 'Hide Details',
    compact = false,
  } = props;
  const uniqueProducts = getUniqueProducts(products);
  const numberOfProductsToShow = 3;
  const productsToShow = uniqueProducts.slice(0, numberOfProductsToShow);
  const productsToHide = uniqueProducts.slice(numberOfProductsToShow);

  return (
    <Styled.AskProductOrderDetailsWrapper
      compact={compact}
      isActive={isOrderDetailsOpen}
    >
      <Styled.OrderDetailsToggle
        isActive={isOrderDetailsOpen}
        onClick={onToggleClick}
      >
        {isOrderDetailsOpen ? (
          compact ? null : (
            <Typography variant="tiny" fontWeight={400} sx={{ lineHeight: 1 }}>
              {hideDetailsLabel}
            </Typography>
          )
        ) : (
          <Styled.OrderDetailsThumbnails>
            {productsToShow.map((product, index) => (
              <Styled.OrderDetailsThumbnail key={index} bg={product.photo} />
            ))}
            {productsToHide.length > 0 && (
              <Styled.OrderDetailsCounter>
                <Typography variant="tiny" fontWeight={600}>
                  <span>{productsToHide.length}+</span>
                </Typography>
              </Styled.OrderDetailsCounter>
            )}
          </Styled.OrderDetailsThumbnails>
        )}
        <Styled.ToggleButton
          isActive={isOrderDetailsOpen}
          endIcon="down"
          color="primary"
          size="small"
          variant="text"
          endIconSize={0.5}
          compact={compact}
        />
      </Styled.OrderDetailsToggle>
    </Styled.AskProductOrderDetailsWrapper>
  );
};
